/* PLTÉ Maison · app (SHELL). Zie ULTRA/build/shell-REPORT.md en ULTRA/verfijning/build/ATC-REPORT.md */
(function () {
  'use strict';
  var P = window.PLTE = window.PLTE || {};
  var S = P.settings || {}, T = P.strings || {}, R = P.routes || {};
  var html = document.documentElement;
  var mq = function (q) { return !!(window.matchMedia && matchMedia(q).matches); };
  var reduce = mq('(prefers-reduced-motion: reduce)'), fine = mq('(pointer: fine)');
  var calm = html.getAttribute('data-motion') === 'calm', off = html.hasAttribute('data-motion-off');
  var design = !!(window.Shopify && Shopify.designMode);
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); };
  var attr = function (el, k) { return el.getAttribute('data-' + k); };
  function safe(name, fn) { try { fn(); } catch (e) { if (window.console) console.warn('[PLTÉ] ' + name, e); } }
  P.safe = safe;
  var ev = function (el, n, d) { el.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: d })); };

  /* geld volgens shop.money_format */
  function formatMoney(cents, format) {
    var f = format || P.moneyFormat || '€{{amount_with_comma_separator}}', comma = /comma_separator/.test(f);
    var parts = (Math.round(+cents || 0) / 100).toFixed(/no_decimals/.test(f) ? 0 : 2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
    return f.replace(/\{\{\s*\w+\s*\}\}/, parts.join(comma ? ',' : '.'));
  }
  var money = function (c) { return formatMoney(c); };
  P.money = money; P.formatMoney = formatMoney;

  /* sokjes-burst; o.at = {x,y}; lb = tijd van de laatste burst */
  var lb = 0;
  function burstFrom(el, o) {
    if (!el || off || !P.socks || typeof P.socks.burst !== 'function') return;
    o = o || {}; o.surfaceEl = o.surfaceEl || el; lb = Date.now();
    var r = el.getBoundingClientRect(), at = o.at || { x: r.left + r.width / 2, y: r.top + r.height / 2 };
    P.socks.burst(at.x, at.y, o);
  }
  P.burstFrom = burstFrom;

  var toastEl = $('#toast'), toastTimer;
  function toast(msg) { if (!toastEl || !msg) return; toastEl.textContent = msg; toastEl.classList.add('is-on'); clearTimeout(toastTimer); toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600); }
  P.toast = toast;

  /* slot; op touch body fixeren (iOS) */
  var locks = 0, lockY = 0, coarse = mq('(pointer: coarse)');
  function lock(on) {
    var was = locks > 0; locks = Math.max(0, locks + (on ? 1 : -1)); var now = locks > 0;
    html.classList.toggle('is-locked', now);
    if (coarse && now !== was) {
      if (now) { lockY = window.scrollY; document.body.style.top = -lockY + 'px'; html.classList.add('is-fixed'); }
      else { html.classList.remove('is-fixed'); document.body.style.top = ''; window.scrollTo(0, lockY); }
    }
    if (P.lenis) { now ? P.lenis.stop() : P.lenis.start(); }
  }

  /* The Threshold */
  safe('intro', function () {
    var el = $('[data-intro]'), active = html.classList.contains('threshold-active');
    function done() { html.classList.remove('threshold-active'); html.classList.add('threshold-done'); if (el) el.remove(); ev(document, 'plte:intro-done'); }
    if (!el || !active) { html.classList.remove('threshold-active'); html.classList.add('no-intro', 'threshold-done'); if (el) el.remove(); setTimeout(function () { ev(document, 'plte:intro-done'); }, 60); return; }
    var ms = clamp(S.introMs || 1200, 1200, 3000), leaving = false, elapsed = P.introStart ? performance.now() - P.introStart : 0;
    function leave() { if (leaving) return; leaving = true; el.classList.add('is-leaving'); setTimeout(done, 1000); }
    setTimeout(leave, Math.max(0, Math.max(ms - 850, 1000) - elapsed));
    function skip() { if (leaving) return; leaving = true; el.style.transition = 'opacity .35s ease'; el.style.opacity = '0'; setTimeout(done, 360); }
    el.addEventListener('click', skip);
    document.addEventListener('keydown', function onKey(e) { if (e.key === 'Escape' || e.key === 'Enter' || e.key === ' ') { skip(); document.removeEventListener('keydown', onKey); } });
  });

  /* dagdeel */
  safe('daypart', function () {
    if (S.daypart === false || !T.evening) return;
    var h = new Date().getHours();
    if (h >= 18 || h < 4) $$('[data-daypart-text]').forEach(function (n) { n.textContent = T.evening; });
  });

  /* scroll */
  var scrollY = window.scrollY || 0, scrollFns = [], nativeOn = false;
  function onScroll(fn) { scrollFns.push(fn); }
  function fire() { for (var i = 0; i < scrollFns.length; i++) scrollFns[i](scrollY); }
  function nativeScroll() {
    if (nativeOn) return; nativeOn = true; var ticking = false;
    window.addEventListener('scroll', function () { if (P.lenis) return; scrollY = window.scrollY; if (!ticking) { ticking = true; requestAnimationFrame(function () { fire(); ticking = false; }); } }, { passive: true });
  }
  P.onScroll = onScroll; P.scrollY = function () { return scrollY; };
  /* Lenis alleen op fijne pointers (§12) */
  safe('scroll', function () {
    function startLenis() {
      try {
        var lenis = new window.Lenis({ lerp: 0.085, wheelMultiplier: 0.9, smoothWheel: true, syncTouch: false, autoRaf: true, anchors: true, allowNestedScroll: true });
        P.lenis = lenis;
        lenis.on('scroll', function (e) { scrollY = e.scroll; fire(); });
        if (html.classList.contains('threshold-active') || locks) { lenis.stop(); document.addEventListener('plte:intro-done', function () { if (!locks) lenis.start(); }, { once: true }); }
      } catch (e) { P.lenis = null; }
    }
    nativeScroll();
    if (S.smoothScroll === false || !fine || reduce || calm || off || design) return;
    if (window.Lenis) return startLenis();
    var src = P.assets && P.assets.lenis; if (!src) return;
    var sc = document.createElement('script'); sc.src = src; sc.onload = startLenis; document.head.appendChild(sc);
  });
  P.scrollTo = function (el, o) {
    o = o || {}; if (!el) return;
    if (P.lenis) P.lenis.scrollTo(el, { offset: o.offset != null ? o.offset : -120, duration: o.duration });
    else el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: o.block || 'center' });
  };

  /* header */
  safe('header', function () {
    var hdr = $('[data-header]'); if (!hdr) return;
    var transparent = attr(hdr, 'transparent') === 'true', last = scrollY, hidden = false, vh = window.innerHeight;
    function update(y) {
      if (transparent) { var over = y < vh * 0.72; hdr.classList.toggle('hdr--over', over); hdr.classList.toggle('hdr--solid', !over); }
      else hdr.classList.toggle('hdr--solid', y > 24);
      var d = y - last;
      if (y > 420 && d > 4 && !hidden) { hidden = true; hdr.classList.add('hdr--hidden'); }
      else if ((d < -4 || y < 120) && hidden) { hidden = false; hdr.classList.remove('hdr--hidden'); }
      last = y;
    }
    onScroll(update); update(scrollY);
    window.addEventListener('resize', function () { vh = window.innerHeight; }, { passive: true });
    P.header = { show: function () { hidden = false; hdr.classList.remove('hdr--hidden'); }, el: hdr };
    $$('[data-hdr-panel]', hdr).forEach(function (item) {
      var trig = $('[aria-haspopup]', item), first = $('.hdr__sublink', item), skipFocus = false;
      function set(on) { item.classList.toggle('is-open', on); hdr.classList.toggle('hdr--panel', on); if (trig) trig.setAttribute('aria-expanded', String(on)); }
      item.addEventListener('pointerenter', function (e) { if (e.pointerType !== 'touch') set(true); });
      item.addEventListener('pointerleave', function () { set(false); });
      item.addEventListener('focusin', function () { if (skipFocus) { skipFocus = false; return; } set(true); });
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) set(false); });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { set(false); if (trig && document.activeElement !== trig) { skipFocus = true; trig.focus(); } }
        if (e.key === 'ArrowDown' && document.activeElement === trig && first) { e.preventDefault(); set(true); first.focus(); }
      });
    });
    /* taalkeuze op touch: kiezen = meteen wisselen; terug via bfcache zet de lijst weer op de huidige taal */
    $$('[data-lang-select]', hdr).forEach(function (s) {
      s.addEventListener('change', function () { s.form.submit(); });
      window.addEventListener('pageshow', function () { s.form.reset(); });
    });
  });

  /* overlays met inert op de pagina erachter */
  var inertN = 0;
  function setInert(on) {
    inertN = Math.max(0, inertN + (on ? 1 : -1)); var want = inertN > 0;
    $$('#main, [data-header], footer.ftr, [data-announcement], .skip-link').forEach(function (n) { if (want) n.setAttribute('inert', ''); else n.removeAttribute('inert'); });
  }
  function overlay(root, openBtns, closeBtns, focusSel) {
    if (!root) return null;
    var isOpen = false, lastFocus = null;
    function open() {
      if (isOpen) return; isOpen = true; lastFocus = document.activeElement;
      root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false'); lock(true); setInert(true);
      openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      if (P.header) P.header.show();
      setTimeout(function () { var f = focusSel ? $(focusSel, root) : null; if (f) f.focus(); }, 120);
    }
    function close() {
      if (!isOpen) return; isOpen = false;
      root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true'); lock(false); setInert(false);
      openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    openBtns.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); isOpen ? close() : open(); }); });
    closeBtns.forEach(function (b) { b.addEventListener('click', function () { close(); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) close(); });
    return { open: open, close: close, get isOpen() { return isOpen; } };
  }
  safe('overlays', function () {
    var menu = overlay($('[data-menu]'), $$('[data-menu-open]'), $$('[data-menu-close]'), '.menu__link');
    var search = overlay($('[data-search]'), $$('[data-search-open]'), $$('[data-search-close]'), '[data-search-input]');
    if (menu && search) {
      $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', search.close); });
      $$('[data-search-open]').forEach(function (b) { b.addEventListener('click', menu.close); });
    }
    if (menu) $$('.menu__link').forEach(function (a) { a.addEventListener('click', menu.close); });
  });

  /* reveals */
  safe('reveals', function () {
    $$('[data-reveal="words"]').forEach(function (el) {
      if (el.querySelector('.w')) return;
      var words = el.textContent.trim().split(/\s+/); el.textContent = '';
      words.forEach(function (w, i) { var s = document.createElement('span'); s.className = 'w'; s.style.setProperty('--i', i); s.textContent = w; el.appendChild(s); if (i < words.length - 1) el.appendChild(document.createTextNode(' ')); });
    });
    var items = $$('[data-reveal]'); if (!items.length) return;
    var inView = function (n) { var r = n.getBoundingClientRect(); return r.top < window.innerHeight * 0.9 && r.bottom > 0; };
    if (!('IntersectionObserver' in window) || reduce || off) { items.forEach(function (n) { n.classList.add('is-in'); }); return; }
    var heroItems = $$('.hero [data-reveal], .world-hero [data-reveal]'), queue = [], flushing = false;
    function flush() { var batch = queue.splice(0, 4); batch.forEach(function (n, i) { setTimeout(function () { n.classList.add('is-in'); }, i * 80); }); if (queue.length) setTimeout(flush, 80 * batch.length); else flushing = false; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); queue.push(en.target); } });
      if (queue.length && !flushing) { flushing = true; flush(); }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (n) { if (heroItems.indexOf(n) > -1) return; if (inView(n)) n.classList.add('is-in'); else io.observe(n); });
    html.classList.add('reveal-ready');
    document.addEventListener('transitionend', function (e) { var t = e.target; if (e.propertyName === 'transform' && t && t.hasAttribute && t.hasAttribute('data-reveal') && t.classList.contains('is-in')) t.classList.add('is-settled'); });
    function showHero() { heroItems.forEach(function (n) { n.classList.add('is-in'); }); }
    if (html.classList.contains('threshold-active')) document.addEventListener('plte:intro-done', showHero, { once: true }); else setTimeout(showHero, 120);
    setTimeout(function () { items.forEach(function (n) { if (!n.classList.contains('is-in') && inView(n)) n.classList.add('is-in'); }); }, 2500);
  });

  /* video */
  function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  safe('video', function () {
    var vids = $$('video[data-lazy-video]');
    function auto(v) { if (!off && !v.hasAttribute('data-user-paused')) play(v); }
    if ('IntersectionObserver' in window && vids.length) {
      var vio = new IntersectionObserver(function (entries) { entries.forEach(function (en) { var v = en.target; if (en.isIntersecting) { v.setAttribute('data-in-view', ''); auto(v); } else { v.removeAttribute('data-in-view'); v.pause(); } }); }, { rootMargin: '120px 0px' });
      vids.forEach(function (v) { vio.observe(v); });
    } else vids.forEach(auto);
    document.addEventListener('visibilitychange', function () { $$('video').forEach(function (v) { if (document.hidden) v.pause(); else if (v.hasAttribute('data-in-view')) auto(v); }); });
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-media-toggle]'); if (!b) return;
      var fig = b.closest('.media'), v = fig && $('video', fig); if (!v) return;
      if (v.paused) { v.removeAttribute('data-user-paused'); play(v); } else { v.pause(); v.setAttribute('data-user-paused', ''); }
      var paused = v.hasAttribute('data-user-paused');
      b.setAttribute('aria-pressed', String(paused)); b.setAttribute('aria-label', attr(b, paused ? 'label-play' : 'label-pause') || '');
    });
  });

  /* kaartvideo */
  safe('cardVideo', function () {
    var vids = $$('video[data-card-video]');
    if (!vids.length || reduce || off || (navigator.connection && navigator.connection.saveData)) return;
    var current = null;
    function stop(v) { v.pause(); v.classList.remove('is-playing'); if (current === v) current = null; }
    function start(v) { if (current && current !== v) stop(current); current = v; var p = v.play(); if (p && p.then) p.then(function () { v.classList.add('is-playing'); }).catch(function () {}); }
    if (fine && mq('(hover: hover)')) {
      vids.forEach(function (v) { var host = v.closest('.card') || v.closest('.media'); host.addEventListener('pointerenter', function (e) { if (e.pointerType !== 'touch') start(v); }); host.addEventListener('pointerleave', function () { stop(v); }); });
    } else if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.intersectionRatio >= 0.6) start(en.target); else if (en.target === current) stop(en.target); }); }, { threshold: [0, 0.6] });
      vids.forEach(function (v) { io.observe(v); });
    }
  });

  /* dialogs */
  safe('dialogs', function () {
    P.openDialog = function (id) { var d = document.getElementById(id); if (d && d.showModal && !d.open) { d.showModal(); lock(true); } };
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-open-dialog]'); if (b) P.openDialog(attr(b, 'open-dialog'));
    });
    $$('[data-dialog]').forEach(function (d) {
      $$('[data-close-dialog]', d).forEach(function (b) { b.addEventListener('click', function () { d.close(); }); });
      d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
      d.addEventListener('close', function () { lock(false); });
    });
  });

  /* maatkeuze */
  function pickerState(form) { return { picker: form ? $('[data-size-picker]', form) : null, input: form ? $('input[name="id"]:checked, input[type="hidden"][name="id"]', form) : null }; }
  safe('picker', function () {
    $$('[data-size-picker]').forEach(function (picker) {
      var val = $('[data-picker-value]', picker);
      picker.addEventListener('change', function (e) {
        var inp = e.target; if (inp.type !== 'radio') return;
        picker.classList.remove('is-error');
        $$('.size--radio', picker).forEach(function (l) { var on = l.contains(inp); l.classList.toggle('is-checked', on); if (on) { l.classList.add('is-just'); setTimeout(function () { l.classList.remove('is-just'); }, 450); } });
        if (val) val.textContent = attr(inp, 'variant-title');
        var form = picker.closest('form'), avail = attr(inp, 'available') !== 'false';
        if (!form) return;
        var btn = $('[data-buy-btn]', form), label = $('[data-buy-label]', form), err = $('[data-buy-error]', form.parentNode);
        if (btn) btn.setAttribute('aria-disabled', String(!avail));
        if (label) { label.removeAttribute('data-idle'); label.textContent = avail ? T.addToBag : T.soldOut; }
        if (err) err.hidden = true;
        ev(form, 'plte:variant', { id: inp.value, available: avail, title: attr(inp, 'variant-title') });
      });
    });
  });

  /* mand */
  function fromButton(b) {
    var o = { quantity: 1 };
    ['variant-id', 'name', 'colour', 'variant-title', 'price', 'url', 'slot', 'handle'].forEach(function (k) { o[k.replace('-', '_')] = attr(b, k); });
    o.handle = o.handle || (o.url || '').split('/').pop(); return o;
  }
  var Cart = (function () {
    var preview = !!P.preview, KEY = 'plte-cart-mock', hdrs = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    var state = { items: [], item_count: 0, total_price: 0 }, listeners = [], busy = {};
    function load() { if (!preview) return; try { state = JSON.parse(localStorage.getItem(KEY)) || state; } catch (e) {} }
    function save() { if (preview) { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} } }
    function recompute() { state.item_count = 0; state.total_price = 0; state.items.forEach(function (it) { state.item_count += it.quantity; it.final_line_price = it.price * it.quantity; state.total_price += it.final_line_price; }); }
    /* naam uit de kaart in de lade (custom.name: The Classic, The Cocoon); de Ajax API kent alleen de producttitel "The Grip Sock | …" */
    var names = null;
    function nameOf(it, parts) {
      if (names === null) { names = {}; var el = document.querySelector('[data-cart-names]'); if (el) { try { names = JSON.parse(el.textContent) || {}; } catch (e) {} } }
      return names[it.handle] || (parts[0] || '').trim();
    }
    function normalize(cart) {
      return { item_count: cart.item_count, total_price: cart.total_price, items: (cart.items || []).map(function (it) {
        var parts = (it.product_title || it.title || '').split('|');
        return { key: it.key, variant_id: it.variant_id, quantity: it.quantity, price: it.price, final_line_price: it.final_line_price, name: nameOf(it, parts), colour: (parts[1] || '').trim(), variant_title: it.variant_title || '', url: it.url, image: it.image, handle: it.handle };
      }) };
    }
    function emit() { listeners.forEach(function (fn) { fn(state); }); }
    function fail(r) { return r.json().catch(function () { return {}; }).then(function (j) { throw new Error(j.description || j.message || T.error); }); }
    function get() {
      if (preview) { load(); recompute(); emit(); return Promise.resolve(state); }
      return fetch(R.cart + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : fail(r); }).then(function (c) { state = normalize(c); emit(); return state; });
    }
    /* één POST, ook voor de set */
    function add(line) {
      var lines = Array.isArray(line) ? line : [line];
      if (preview) {
        load();
        lines.forEach(function (l) {
          var ex = state.items.filter(function (it) { return it.variant_id == l.variant_id; })[0];
          if (ex) ex.quantity += l.quantity || 1;
          else state.items.unshift({ key: l.variant_id + ':' + Date.now(), variant_id: l.variant_id, quantity: l.quantity || 1, price: +l.price || 0, name: l.name, colour: l.colour, variant_title: l.variant_title, url: l.url, slot: l.slot, handle: l.handle });
        });
        recompute(); save(); emit(); return Promise.resolve(state);
      }
      return fetch(R.cartAdd + '.js', { method: 'POST', credentials: 'same-origin', headers: hdrs, body: JSON.stringify({ items: lines.map(function (l) { return { id: l.variant_id, quantity: l.quantity || 1 }; }) }) }).then(function (r) { return r.ok ? get() : fail(r); });
    }
    function change(key, q) {
      if (busy[key]) return Promise.resolve(state);
      busy[key] = true; var p;
      if (preview) { load(); state.items = state.items.map(function (it) { if (it.key === key) it.quantity = q; return it; }).filter(function (it) { return it.quantity > 0; }); recompute(); save(); emit(); p = Promise.resolve(state); }
      else p = fetch(R.cartChange + '.js', { method: 'POST', credentials: 'same-origin', headers: hdrs, body: JSON.stringify({ id: key, quantity: q }) }).then(function (r) { return r.ok ? get() : fail(r); });
      return p.then(function (s) { busy[key] = false; return s; }, function (e) { busy[key] = false; throw e; });
    }
    return { get: get, add: add, change: change, on: function (fn) { listeners.push(fn); }, state: function () { return state; }, busy: function (k) { return !!busy[k]; } };
  })();

  /* M1-aantal: eerste Add 6/5, daarna 3 */
  function m1() { var k = 'plte-m1', n = fine ? 6 : 5; try { if (sessionStorage.getItem(k)) n = 3; sessionStorage.setItem(k, '1'); } catch (e) {} return n; }
  P.m1 = m1;

  safe('cart', function () {
    var drawer = $('[data-cart-drawer]'), page = $('[data-cart-page]');
    var ctl = drawer ? overlay(drawer, $$('[data-cart-open]'), $$('[data-cart-close]', drawer), null) : null;
    var threshold = S.freeShippingPairs || 3, nl = S.country === 'NL', lastCount = null, bumpPending = false;
    var pairsOf = function (n) { return n === 1 ? T.pairsOne : (T.pairsOther || '').replace('{{ count }}', n); };
    /* lade-transitie: focus op de kop of bump */
    function bump() { var bag = $('.hdr__bag'); bumpPending = false; if (!bag) return; bag.classList.remove('is-bumped'); void bag.offsetWidth; bag.classList.add('is-bumped'); }
    if (drawer) {
      var panel = $('.drawer__panel', drawer);
      panel.addEventListener('transitionend', function (e) {
        if (e.target !== panel) return;
        if (drawer.classList.contains('is-open')) { var t = $('.drawer__title', drawer); if (t) t.focus(); }
        else { if (bumpPending) bump(); $$('.is-new', drawer).forEach(function (n) { n.classList.remove('is-new'); }); }
      });
    }
    function fill(li, it) {
      li.setAttribute('data-key', it.key); li.setAttribute('data-line-quantity', it.quantity);
      var ln = $('[data-line-name]', li), lp = $('[data-line-price]', li), lm = $('[data-line-meta]', li);
      if (ln) ln.textContent = it.name || '';
      if (lp) lp.textContent = money(it.final_line_price);
      if (lm) lm.innerHTML = (it.colour ? '<i>' + esc(it.colour) + '</i>' : '') + (it.variant_title ? (it.colour ? ' · ' : '') + esc(it.variant_title) : '');
      var qn = $('[data-line-qty]', li); if (qn) { if ('value' in qn) qn.value = it.quantity; else qn.textContent = it.quantity; }
      var a = $('.line__media', li); if (a && it.url) a.href = it.url;
      var img = $('.line__img', li);
      if (it.image && img && img.hidden) { img.src = it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160'; img.alt = it.name || ''; img.hidden = false; var ph = $('.media', li); if (ph) ph.remove(); }
    }
    /* maat in de mand; gelijkspel = geen voorkeur */
    var letter = function (t) { return String(t || '').trim().charAt(0).toUpperCase(); };
    function bagSize(items) {
      var n = { S: 0, M: 0 };
      items.forEach(function (it) { var L = letter(it.variant_title); if (n[L] != null) n[L] += it.quantity || 1; });
      return n.S === n.M ? null : (n.S > n.M ? 'S' : 'M');
    }
    function render(cart) {
      var n = cart.item_count, empty = n === 0, left = Math.max(0, threshold - n);
      if (lastCount !== null && lastCount !== n) page || !ctl ? bump() : bumpPending = true;
      lastCount = n;
      $$('[data-cart-count]').forEach(function (x) { x.textContent = n; });
      $$('[data-cart-pairs]').forEach(function (x) { x.textContent = empty ? '' : pairsOf(n); });
      $$('[data-cart-subtotal]').forEach(function (x) { x.textContent = money(cart.total_price); });
      $$('[data-cart-items]').forEach(function (list) { /* diffen op data-key, focus behouden (CA-05) */
        var scope = list.closest('[data-cart-drawer], [data-cart-page]'), tpl = scope && $('[data-line-template]', scope); if (!tpl) return;
        var act = document.activeElement, row = act && list.contains(act) ? act.closest('[data-line]') : null;
        var focus = row ? [attr(row, 'key'), attr(act, 'qty')] : null, have = {};
        $$('[data-line]', list).forEach(function (li) { have[attr(li, 'key')] = li; });
        var order = cart.items.map(function (it, i) { var li = have[it.key]; if (li) delete have[it.key]; else { li = tpl.content.firstElementChild.cloneNode(true); li.classList.add('is-new'); } li.style.setProperty('--i', i); fill(li, it); return li; });
        Object.keys(have).forEach(function (k) { have[k].remove(); });
        order.forEach(function (li, i) { if (list.children[i] !== li) list.insertBefore(li, list.children[i] || null); });
        if (focus) { var b = $('[data-line][data-key="' + focus[0] + '"] [data-qty="' + focus[1] + '"]', list) || $('[data-line] [data-qty]', list) || $('.drawer__title, .drawer__close', scope); if (b) b.focus(); }
      });
      $$('[data-cart-empty]').forEach(function (x) { x.hidden = !empty; });
      $$('[data-cart-foot], [data-ship-intl]').forEach(function (x) { x.hidden = empty; });
      $$('[data-ship-bar]').forEach(function (bar) {
        bar.hidden = empty;
        bar.style.setProperty('--p', Math.min(1, n / threshold));
        var txt = $('[data-ship-text]', bar), cost = $('[data-ship-cost]', bar);
        if (txt) txt.textContent = left === 0 ? T.progressDone : (left === 1 ? T.progressOne : (T.progressOther || '').replace('{{ count }}', left));
        if (cost) cost.hidden = left === 0;
        bar.classList.toggle('is-done', left === 0);
      });
      if (nl) $$('[data-cart-note]').forEach(function (x) { if (!x._b) x._b = x.textContent; x.textContent = left === 0 ? attr(x, 'free') : x._b; });
      /* Pair it with: silhouet, maat, voorraad, 2 → 1 → 0 */
      $$('[data-cart-upsell]').forEach(function (up) {
        var inCart = {}, kinds = {}, shown = 0, size = bagSize(cart.items), max = left === 0 || !nl ? 1 : 2;
        cart.items.forEach(function (it) { if (it.handle) inCart[it.handle] = 1; if (it.url) inCart[it.url.split('/').pop().split('?')[0]] = 1; kinds[/cocoon/i.test((it.name || '') + (it.handle || '')) ? 'cocoon' : 'classic'] = 1; });
        var fits = function (u) { return !!$(size && $('[data-size-letter]', u) ? '[data-size-letter="' + size + '"]:not([disabled])' : '[data-add]:not([disabled])', u); };
        var cands = $$('[data-upsell-handle]', up), rank = function (u) { return (kinds[attr(u, 'upsell-kind')] ? 2 : 0) + (inCart[attr(u, 'upsell-handle')] ? 4 : 0) + (fits(u) ? 0 : 1); };
        cands.sort(function (a, b) { return rank(a) - rank(b); }).forEach(function (u) {
          up.appendChild(u);
          var show = !inCart[attr(u, 'upsell-handle')] && fits(u) && shown < max; u.hidden = !show; if (show) shown++;
          var hint = $('[data-upsell-hint]', u), label = $('[data-upsell-label]', u), hit = false;
          $$('[data-size-letter]', u).forEach(function (b) {
            var on = !!size && attr(b, 'size-letter') === size && !b.disabled; b.classList.toggle('is-suggested', on); if (on) hit = true;
            b.textContent = on ? T.addSuggested.replace('{{ size }}', size) : attr(b, 'size-letter');
          });
          if (hint) { hint.hidden = !hit; hint.textContent = hit ? T.sameSize : ''; }
          if (label) label.hidden = hit;
        });
        var why = $('[data-upsell-reason]', up), r = n === 1 ? (kinds.classic ? T.reasonClassic : T.reasonCocoon) : (n === 2 && nl && left === 1 ? T.reasonThree : '');
        if (why) { why.textContent = r; why.hidden = !r; }
        up.hidden = empty || shown === 0;
      });
    }
    Cart.on(render); Cart.get();
    /* M1: morf 1,4 s, burst, status, plte:added */
    function added(btn, labelEl, line, o) {
      o = o || {}; line = line || {}; var seen = false;
      if (btn) {
        var el = labelEl || btn, isSize = btn.classList.contains('size'), r = btn.getBoundingClientRect(), at = o.at || { x: r.left + r.width / 2, y: r.top + r.height / 2 };
        seen = !!(o.at || r.width) && at.y > 0 && at.y < innerHeight;
        var L = letter(line.variant_title);
        if (!isSize) { if (!el.hasAttribute('data-idle')) el.setAttribute('data-idle', el.textContent); el.textContent = T.addedShort + (/^[SM]$/.test(L) ? ' · ' + L : ''); }
        btn.classList.add('is-added');
        setTimeout(function () { if (!isSize && el.hasAttribute('data-idle')) el.textContent = el.getAttribute('data-idle'); btn.classList.remove('is-added'); }, 1400);
        if (seen) burstFrom(btn, { count: Math.min(m1(), Date.now() - lb < 1500 ? 3 : 9), mode: 'cone', at: at });
      }
      var st = $('#cart-status'); if (st) st.textContent = T.statusAdded.replace('{{ item }}', [line.name, line.colour, line.variant_title].filter(Boolean).join(' · ')).replace('{{ pairs }}', pairsOf(Cart.state().item_count));
      ev(btn || document, 'plte:added', { el: btn, line: line, seen: seen });
      if (!page) ctl ? setTimeout(ctl.open, o.delay || 350) : toast(T.added);
    }
    function showErr(el, x) { if (el) { el.textContent = x.message || T.error; el.hidden = false; } else toast(x.message || T.error); }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-add]'); if (!b || b.disabled || b.getAttribute('aria-disabled') === 'true' || b.getAttribute('aria-busy') === 'true') return;
      e.preventDefault(); b.setAttribute('aria-busy', 'true');
      var r = b.getBoundingClientRect(), at = { x: r.left + r.width / 2, y: r.top + r.height / 2 }, line = fromButton(b), err = $('[data-add-error]', b.closest('.upsell') || b);
      if (err) err.hidden = true;
      Cart.add(line).then(function () { added(b, null, line, { at: at }); }).catch(function (x) { showErr(err, x); }).then(function () { b.removeAttribute('aria-busy'); });
    });
    $$('[data-buy-form]').forEach(function (form) {
      form.noValidate = true; /* eigen maatmelding */
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var st = pickerState(form), btn = $('[data-buy-btn]', form), label = $('[data-buy-label]', form), err = $('[data-buy-error]', form.parentNode);
        if (!st.input) { if (st.picker) { st.picker.classList.add('is-error', 'is-shake'); setTimeout(function () { st.picker.classList.remove('is-shake'); }, 450); var v = $('[data-picker-value]', st.picker); if (v) v.textContent = T.chooseSize; $('input', st.picker).focus(); } return; }
        if (attr(st.input, 'available') === 'false') { var vid = st.input.value, pu = attr(form, 'url'); if ($('[data-bis-for="' + vid + '"]')) ev(form, 'plte:notify', { id: vid }); else if (pu) location.href = pu + '#bis-' + vid; else if (label) label.textContent = T.soldOut; return; }
        if (btn && btn.getAttribute('aria-busy') === 'true') return;
        if (btn) btn.setAttribute('aria-busy', 'true');
        if (label) { if (!label.hasAttribute('data-idle')) label.setAttribute('data-idle', label.textContent); label.textContent = T.adding; }
        if (err) err.hidden = true;
        if (!form._pj) { form._pj = {}; try { var sect = form.closest('[data-product]'), node = sect && $('[data-product-json]', sect); if (node) form._pj = JSON.parse(node.textContent); } catch (x) {} }
        var pj = form._pj, vinfo = (pj.variants || []).filter(function (v) { return String(v.id) === String(st.input.value); })[0] || {};
        var line = { variant_id: st.input.value, quantity: 1, name: attr(form, 'name') || pj.name, colour: attr(form, 'colour') || pj.colour, variant_title: attr(st.input, 'variant-title'), price: vinfo.price || attr(st.input, 'price') || (btn && attr(btn, 'price')), url: attr(form, 'url') || pj.url, slot: attr(form, 'slot') || pj.slot, handle: attr(form, 'product-handle') || pj.handle };
        Cart.add(line)
          .then(function () { added(btn, label, line); })
          .catch(function (x) { if (label && label.hasAttribute('data-idle')) label.textContent = label.getAttribute('data-idle'); showErr(err, x); })
          .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
      });
    });
    /* hoeveelheid en verwijderen */
    document.addEventListener('click', function (e) {
      var q = e.target.closest('[data-qty]'), rm = e.target.closest('[data-line-remove]'); if (!q && !rm) return;
      var li = e.target.closest('[data-line]'); if (!li) return;
      var key = attr(li, 'key'); if (Cart.busy(key)) return;
      var next = rm ? 0 : Math.max(0, +(attr(li, 'line-quantity') || 1) + (+attr(q, 'qty')));
      li.setAttribute('aria-busy', 'true');
      Cart.change(key, next).catch(function (x) { showErr($('[data-line-error]', li), x); }).then(function () { li.removeAttribute('aria-busy'); });
    });
    if (P.preview) document.addEventListener('click', function (e) { if (e.target.closest('[data-checkout]')) { e.preventDefault(); toast('Checkout: only on Shopify.'); } });
    /* cookiebalk-hoogte als --pc-h */
    var ro;
    function pc() {
      var b = document.getElementById('shopify-pc__banner');
      html.style.setProperty('--pc-h', (b ? b.offsetHeight : 0) + 'px');
      if (b && !ro && window.ResizeObserver) { ro = new ResizeObserver(pc); ro.observe(b); }
    }
    pc(); new MutationObserver(pc).observe(document.body, { childList: true });
    Cart.added = added; Cart.open = function () { ctl && ctl.open(); }; Cart.close = function () { ctl && ctl.close(); }; P.cart = Cart;
  });

  /* kaart quick add op touch */
  document.addEventListener('click', function (e) {
    var l = e.target.closest('.card__quick-label'); if (!l) return;
    e.preventDefault(); var card = l.closest('.card');
    $$('.card.is-open').forEach(function (c) { if (c !== card) { c.classList.remove('is-open'); var b = $('.card__quick-label', c); if (b) b.setAttribute('aria-expanded', 'false'); } });
    l.setAttribute('aria-expanded', String(card.classList.toggle('is-open')));
  });

  /* Find your pair */
  safe('quiz', function () {
    var root = $('[data-quiz]'); if (!root) return;
    var ctl = overlay(root, $$('[data-quiz-open]'), $$('[data-quiz-close]', root), '.quiz__opt');
    var data = {}; try { data = JSON.parse($('[data-quiz-products]', root).textContent); } catch (e) {}
    if (!data.copy) return;
    var steps = $$('[data-quiz-step]', root), prog = $('[data-quiz-progress]', root), panel = $('.quiz__panel', root), answers = {}, chosen = {}, withHandle = null;
    function show(id) { steps.forEach(function (s) { s.classList.toggle('is-active', attr(s, 'quiz-step') === String(id)); }); if (prog) prog.style.setProperty('--w', (id === 'result' ? 100 : id * 33) + '%'); }
    function tag(k, v) { if (window.clarity) try { window.clarity('set', k, v); } catch (e) {} }
    function result() {
      var q1 = answers[1], q2 = answers[2], q3 = answers[3];
      var warm = q2 === 'warm' || q1 === 'home', grip = q2 === 'grip' && !warm;
      var w = data['with'] && withHandle && data['with'].handle === withHandle ? data['with'] : null, key, lines;
      if (q3 === '3') {
        key = 'set';
        lines = w ? (w.kind === 'cocoon' ? [['with', 1], ['classic', 2]] : [['with', 2], ['cocoon', 1]]) : grip ? [['classic', 2], ['classic2', 1]] : warm ? [['cocoon', 2], ['classic', 1]] : [['classic', 2], ['cocoon', 1]];
      } else if (q3 === '2') { key = 'pair'; lines = grip ? [['classic', 1], ['classic2', 1]] : [['classic', 1], ['cocoon', 1]]; }
      else if (warm) { key = 'cocoon'; lines = [['cocoon', 1]]; }
      else { key = 'classic'; lines = [['classic', 1]]; }
      $('[data-quiz-title]', root).textContent = data.copy[key].title;
      $('[data-quiz-text]', root).textContent = data.copy[key].text;
      var box = $('[data-quiz-items]', root); box.textContent = ''; chosen = {};
      lines.forEach(function (l, i) {
        var p = data[l[0]]; if (!p || !p.variants || !p.variants.length) return;
        var rk = l[0] + i, row = document.createElement('div');
        row.className = 'quiz__item'; row.setAttribute('data-quiz-line', rk); row.setAttribute('data-quiz-key', l[0]); row.setAttribute('data-quiz-qty', l[1]);
        var h = '<span class="quiz__item-name">' + (l[1] > 1 ? l[1] + ' × ' : '') + esc(p.name) + ' <i>' + esc(p.colour) + '</i></span>';
        if (p.single || p.variants.length === 1) { var v0 = p.variants[0]; if (v0.available !== false) chosen[rk] = v0; h += '<span class="t-small">' + esc(v0.available === false ? T.soldOut : (p.single ? data.copy.one_size : v0.title)) + '</span>'; }
        else h += '<span class="sizes sizes--inline" role="group">' + p.variants.map(function (v) { return '<button class="size' + (v.available ? '' : ' size--off') + '" type="button" data-quiz-size="' + v.id + '" data-title="' + esc(v.title) + '"' + (v.available ? '' : ' disabled') + '>' + esc(String(v.title).split(' ')[0]) + '</button>'; }).join('') + '</span>';
        h += '<span class="t-small">' + money(p.price * l[1]) + '</span><a class="link link--sm" href="' + esc(p.url) + '">' + esc(data.copy.view) + '</a>';
        row.innerHTML = h; box.appendChild(row);
      });
      show('result'); tag('quiz_result', key);
      setTimeout(function () { burstFrom($('[data-quiz-anchor]', root), { count: 4, mode: 'cone' }); }, 250);
    }
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-quiz-answer]');
      if (a) { var step = +attr(a.closest('[data-quiz-step]'), 'quiz-step'); answers[step] = attr(a, 'quiz-answer'); step < 3 ? show(step + 1) : result(); return; }
      var sz = e.target.closest('[data-quiz-size]');
      if (sz) { var row = sz.closest('[data-quiz-line]'); $$('[data-quiz-size]', row).forEach(function (x) { x.classList.remove('is-selected'); }); sz.classList.add('is-selected'); chosen[attr(row, 'quiz-line')] = { id: attr(sz, 'quiz-size'), title: attr(sz, 'title') }; return; }
      if (e.target.closest('[data-quiz-restart]')) { answers = {}; show(1); return; }
      var qb = e.target.closest('[data-quiz-add]');
      if (qb && qb.getAttribute('aria-busy') !== 'true') { /* busy-guard, één POST */
        var rows = $$('[data-quiz-line]', root), missing = rows.filter(function (r) { return !chosen[attr(r, 'quiz-line')]; });
        if (missing.length) { missing.forEach(function (r) { r.classList.add('is-shake'); setTimeout(function () { r.classList.remove('is-shake'); }, 450); }); toast(T.chooseSize); return; }
        qb.setAttribute('aria-busy', 'true');
        var items = rows.map(function (r) { var p = data[attr(r, 'quiz-key')], v = chosen[attr(r, 'quiz-line')]; return { variant_id: v.id, quantity: +attr(r, 'quiz-qty'), name: p.name, colour: p.colour, variant_title: v.title, price: p.price, url: p.url, slot: p.slot, handle: p.handle }; });
        Cart.add(items).then(function () {
          tag('set_added', '1');
          if (P.cart) P.cart.added(qb, null, { name: $('[data-quiz-title]', root).textContent.replace(/\.$/, '') }, { delay: 650 });
          setTimeout(ctl.close, 300);
        }).catch(function (x) { toast(x.message || T.error); qb.removeAttribute('aria-busy'); });
      }
    });
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-quiz-open]'); if (!b) return;
      withHandle = attr(b, 'quiz-with') || null;
      if (attr(b, 'quiz-open') === 'set') { answers = { 3: '3' }; result(); } else { answers = {}; show(1); }
    });
    root.addEventListener('transitionend', function (e) { if (e.target === panel && !root.classList.contains('is-open')) { answers = {}; show(1); $('[data-quiz-add]', root).removeAttribute('aria-busy'); } });
  });

  /* formulieren */
  safe('forms', function () {
    $$('[data-list-ok]').forEach(function (ok) { if (location.hash === '#' + attr(ok, 'list-ok')) burstFrom(ok, { count: 7, mode: 'ring' }); else ok.remove(); });
    $$('.list-form').forEach(function (f) {
      f.addEventListener('submit', function (e) {
        if (!P.preview) return; e.preventDefault();
        var ok = $('.list-form__ok', f); if (!ok) { ok = document.createElement('p'); ok.className = 'list-form__ok'; f.appendChild(ok); }
        ok.textContent = T.listOk; var inp = $('.list-form__input', f); if (inp) inp.value = '';
        burstFrom($('.list-form__btn', f) || f, { count: 7, mode: 'ring' });
      });
    });
    $$('[data-loc-submit]').forEach(function (sel) { sel.addEventListener('change', function () { if (!P.preview) sel.form.submit(); else toast('Country and language switch via Shopify Markets.'); }); });
  });

  /* Motion on/off */
  safe('motion', function () {
    $$('[data-motion-toggle]').forEach(function (b) {
      var st = $('[data-motion-state]', b);
      function paint() { var on = !html.hasAttribute('data-motion-off'); b.setAttribute('aria-pressed', String(on)); if (st) st.textContent = attr(st, on ? 'on' : 'off'); }
      paint();
      b.addEventListener('click', function () {
        var turnOn = html.hasAttribute('data-motion-off');
        if (turnOn) html.removeAttribute('data-motion-off'); else html.setAttribute('data-motion-off', '');
        try { localStorage.setItem('plte-motion', turnOn ? 'on' : 'off'); } catch (e) {}
        if (!turnOn && P.lenis) { try { P.lenis.destroy(); } catch (e) {} P.lenis = null; nativeScroll(); }
        off = !turnOn; paint();
        ev(document, 'plte:motion', { on: turnOn });
      });
    });
  });

  ev(document, 'plte:ready');
})();
